module.exports = __webpack_public_path__ + "img/1.4a7fc1de.png";